module.exports = __webpack_public_path__ + "img/preguntas_frecuentes.abf05177.png";